/*!
 * ws: a node.js websocket client
 * Copyright(c) 2011 Einar Otto Stangvik <einaros@gmail.com>
 * MIT Licensed
 */

exports.Validation = {
  isValidUTF8: function(buffer) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/ws/lib/Validation.fallback.js
// module id = 1530
// module chunks = 1